// extracted by mini-css-extract-plugin
export default {"expertiseStyles":"Expertise_expertiseStyles__bT+fZ","images":"Expertise_images__PLgfz"};